import React from 'react';
import { Download, X, Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePWAInstall } from '../../hooks/usePWAInstall';

/**
 * PWA Install Banner - Shows when app is installable
 */
const PWAInstallBanner = () => {
    const { t } = useTranslation();
    const { isInstallable, promptInstall, dismiss } = usePWAInstall();

    if (!isInstallable) return null;

    const handleInstall = async () => {
        const result = await promptInstall();
        console.log('Install result:', result);
    };

    return (
        <div className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-40 animate-in slide-in-from-bottom-8">
            <div className="bg-gradient-to-r from-red-900 to-red-800 border border-red-700 rounded-2xl p-4 shadow-2xl shadow-red-900/30">
                <div className="flex items-start gap-3">
                    <div className="bg-white/10 p-2 rounded-xl">
                        <Smartphone size={24} className="text-white" />
                    </div>

                    <div className="flex-1 min-w-0">
                        <h3 className="text-white font-black text-sm uppercase">
                            {t('pwa.install_title') || 'Instalar App'}
                        </h3>
                        <p className="text-red-200 text-xs mt-0.5">
                            {t('pwa.install_desc') || 'Accede más rápido desde tu pantalla de inicio'}
                        </p>

                        <div className="flex gap-2 mt-3">
                            <button
                                onClick={handleInstall}
                                className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-red-900 rounded-lg font-bold text-xs uppercase tracking-wider hover:bg-red-100 transition-colors"
                            >
                                <Download size={12} />
                                {t('pwa.install_btn') || 'Instalar'}
                            </button>
                            <button
                                onClick={dismiss}
                                className="px-3 py-1.5 text-red-200 hover:text-white text-xs font-bold uppercase tracking-wider transition-colors"
                            >
                                {t('pwa.later') || 'Ahora no'}
                            </button>
                        </div>
                    </div>

                    <button
                        onClick={dismiss}
                        className="p-1 text-red-300 hover:text-white transition-colors"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PWAInstallBanner;
